import { ComponentDataTable, TableTypes } from "@develos/next-components";
import { LiveViewStoreType } from "./types";
import { VehicleRecordDetailsType } from "@/types/vehicles";

export const initialState: LiveViewStoreType = {
    autoUpdateVehicleDetails: true,
    metricPointPlatformsUIds: [],
    vehiclesTable: { ...TableTypes.emptyComponentDataTable } as ComponentDataTable<VehicleRecordDetailsType>,
    vehiclesList: []
};